<template>
  <div id="app" ref="app">
    <nav>
      <input
        id="input"
        :value="number"
        @input="onInput"
        type='number'
      >
      <div class="actions">
        <a href="https://filosophy.org/projects">more @ filosophy</a>
      </div>
    </nav>
    <main ref="main">
      <TallyMarks
        v-show="!svgDataUrl"
        v-if="number && number > 0"
        id="tallies"
        :number=number
        :containerWidth=containerWidth
        :containerHeight=containerHeight
      />
      <img
        v-show="svgDataUrl"
        :src="svgDataUrl"
        id="rendering"
        >
    </main>
  </div>
</template>

<script>
import TallyMarks from './components/TallyMarks';
import {
  RENDER_DEBOUNCE_MS,
} from './components/Constants';

export default {
  name: 'App',
  components: {
    TallyMarks,
  },
  data() {
    return {
      number: 128,
      min: 1,
      max: 100000,
      svgDataUrl: '',
      containerWidth: 1,
      containerHeight: 1,
    };
  },
  methods: {
    onResize() {
      const container = this.$refs.main;
      if (!container) {
        return;
      }
      this.containerWidth = container.offsetWidth;
      this.containerHeight = container.offsetHeight;
    },
    onInput(e) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        const value = parseInt(e.target.value, 10);
        this.setNumber(value);
      }, RENDER_DEBOUNCE_MS);
    },
    setNumber(number) {
      this.svgDataUrl = '';
      if (isNaN(number)) {
        this.number = null;
        return;
      }
      this.number = this.clamp(number, this.min, this.max);
    },
    onKeydown(e) {
      if (e.keyCode === 38) {
        // up
        this.setNumber(this.number + 1);
        e.preventDefault();
      } else if (e.keyCode === 40) {
        // down
        this.setNumber(this.number - 1);
        e.preventDefault();
      }
    },
    onWheel(e) {
      if (e.deltaY > 0) {
        // up
        this.setNumber(this.number + 1);
      } else if (e.deltaY < 0) {
        // down
        this.setNumber(this.number - 1);
      }
    },
    onTouchstart(e) {
      const firstTouch = e.touches[0];
      this.lastTouchY = firstTouch.screenY;
    },
    onTouchmove(e) {
      const screenY = e.touches[0].screenY;
      const deltaY = screenY - this.lastTouchY;
      if (deltaY < 0) {
        // up
        this.setNumber(this.number + 1);
      } else if (deltaY > 0) {
        // down
        this.setNumber(this.number - 1);
      }
      this.lastTouchY = screenY;
      e.preventDefault();
    },
    clamp(val, min, max) {
      return Math.min(max, Math.max(min, val));
    },
    setHash() {
      if (window.history) {
        const hash = this.number ? `#${this.number}` : '';
        window.history.replaceState(undefined, undefined, hash);
      }
    },
  },
  watch: {
    number() {
      this.setHash();
    },
  },
  mounted() {
    const hash = parseInt(window.location.hash.slice(1), 10);
    if (hash) {
      this.number = hash;
    } else {
      this.setHash();
    }

    window.addEventListener('keydown', this.onKeydown);
    window.addEventListener('wheel', this.onWheel);
    window.addEventListener('touchstart', this.onTouchstart);
    window.addEventListener('touchmove', this.onTouchmove);
    this.$events.$on('svgUpdated', (serializedSvg) => {
      this.svgDataUrl = `data:image/svg+xml;base64,${window.btoa(serializedSvg)}`;
    });

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(this.onResize, RENDER_DEBOUNCE_MS);
    });
    this.onResize();
  },
};
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

nav {
  padding: 8px;
  display: flex;
}

nav .actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  color: #95cbec;
}

nav .actions a {
  color: #95cbec;
}

input {
  font-size: 18px;
  border: 0;
}

main{
  flex-grow: 1;
  overflow: hidden;
  display: flex;
  position: relative;
}

#tallies {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue